const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_PROJECT_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_PROJECT_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_PROJECT_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_PROJECT_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_PROJECT_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_PROJECT_MEASUREMENT_ID,
};

export default firebaseConfig;
